import React from "react";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import {Button} from "reactstrap";
import {Card, CardContent} from "@material-ui/core";
import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import Select from "react-select";
import classNames from 'classnames';
import {guardOpenWorkOrderBeforeAdd} from '../../utils/openWorkOrderWarning';

const checkboxStyle = { width: 18, height: 18, cursor: "pointer", accentColor: '#16a34a' };

class Inventories extends Framework.Components.Collection {
	static name = "Inventories";
	constructor(props) {
		//reset filter on mount
		localStorage.removeItem('table-preferences-Inventories');
		let model = new API.BuildClass(Types.Inventories._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.limit = 16;
		this.state.selectedGroups = [];
		this.state.groups = [];
		this.state.selectedItems = [];
	}

	async componentDidMount() {
		await this.getGroups();

		if (typeof this.props.history.location.state.receivedGroup.pkey !== 'undefined') {
			this.handleGroups(
				[{
					value: this.props.history.location.state.receivedGroup.pkey,
					label: this.props.history.location.state.receivedGroup.name
				}]
			);
		}
	}

	getGroups = async () => {
		let groupModel = new API.BuildClass(Types.Skus_Classes._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		//TODO: should probs move this to the backend
		groupModel.limit = 100;
		try {
			this.groups = await groupModel.submit(null, this.read);

			this.setState({groups: this.groups.items});

		} catch (error) {
			console.log(error, 'error')
		}
	}

	handleGroups = (value) => {
		if (value) {
			let groups = [];
			for (let i = 0; i < value.length; i++) {
				groups.splice(0, 0, value[i]);
			}
			this.state.selectedGroups = groups;
			this.setState({selectedGroups: groups})
		} else {
			this.state.selectedGroups = [];
		}
		//refreshing the data after passing filters
		this.state.filter = {'filterGroups': this.state.selectedGroups.map((group) => group.value)}
		this.reloadTable();
	}

	addToCart = (inventory, serial, taxable = true, itemLabel = 'This item') => async () => {
		const proceed = await guardOpenWorkOrderBeforeAdd(inventory, itemLabel);
		if (!proceed) {
			return;
		}
		let item = new API.BuildClass(Types.Checkouts_Items._name, API.RequestType.CREATE);
		item.properties.inventory.value = inventory;
		item.object = {
			inventory: inventory,
			serial: serial,
			quantity: '1',
			taxable: taxable
		}
		item.submit(null, API.RequestType.CREATE).then(() => {
			this.handleCheckoutIncrement();
		});

	};

	handleCheckoutIncrement = () => {
		this.props.rootState.set({
			session_items_count: this.props.rootState.session_items_count === null ? 1 : 1 + this.props.rootState.session_items_count
		});
	}

	// Method to handle what happens when the user checks or unchecks an individual item's checkbox.
	handleCheckboxChange = async (item, event) => {
		// If checkbox is checked, item is added to selectedItems array in the state. If unchecked, it is removed
		// from the same array.
		if (event) {
			await this.setState(prevState => ({
				selectedItems: [...prevState.selectedItems, item]
			}));
		} else {
			await this.setState(prevState => ({
				selectedItems: prevState.selectedItems.filter(selectedItem => selectedItem !== item)
			}));
		}

		// Any items with the selectedItems array will be sent up to components\Inventories to be uses in a mass action.
		if (typeof this.props.sendData === "function") {
			this.props.sendData(this.state.selectedItems);
		}
	};

	// This is the same at the handleCheckboxChange, but for the select all checkbox in the column header.
	handleMasterCheckboxChange = async (event) => {
		const { data } = this.state;

		if (event) {
			await this.setState({
				selectedItems: [...data]
			});
		} else {
			await this.setState({
				selectedItems: []
			});
		}

		if (typeof this.props.sendData === "function") {
			this.props.sendData(this.state.selectedItems);
		}
	};

	// This method ensures that individual item's checkboxes remain checked even if the user changes pages on the
	// collection table.
	isItemSelected  = (itemId) => {
		return this.state.selectedItems.some(e => e.pkey === itemId.pkey);
	};

	// This method is the same as isItemSelected, except it applies only to the select all checkbox in the column
	// header.
	isAllSelected = () => {
		const { data, selectedItems } = this.state;
		return data.length > 0 && data.every(item => selectedItems.some(e => e.pkey === item.pkey));
	};

	render() {
		const {data, pages, loading, limit} = this.state;
		let columns = [];

		if (this.props.showCheckboxes) {
			columns.push({
				id: "checkbox",
				width: 40,
				sortable: false,
				accessor: r => r.skus.pkey,
				Header: () => (
					<input
						type="checkbox"
						checked={this.isAllSelected()}
						style={checkboxStyle}
						onChange={(property) => {this.handleMasterCheckboxChange(property.currentTarget.checked)}}
					/>
				),
				Cell: props => <input
					type="checkbox"
					checked={this.isItemSelected(props.original)}
					style={checkboxStyle}
					onChange={(property) => {this.handleCheckboxChange(props.original, property.currentTarget.checked)}}
					/>
			});
		}

		columns.push(
			{
				Header: "Name",
				id: "skus.name",
				className: 'center-column',
				accessor: r => r.skus.name,
				Cell: props => <Link to={{
					pathname: "/inventory/" + props.original.pkey,
					inventoryProps: {parent: props.original.pkey}
				}}>{props.value}</Link>
			},
			{
				Header: "SKU",
				id: "skus.sku",
				className: "center-column",
				accessor: r => r.skus.sku,
				Cell: props => <Link to={"/skus/" + props.original.skus.pkey}>{props.value}</Link>
			},
			{
				Header: "Inventory Group",
				id: "skus.sku_classes.name",
				className: 'center-column',
				accessor: r => r.skus.sku_classes.name,
				Cell: props => <Link
					to={"/skus/classes/" + props.original.skus.class}>{props.value}</Link>
			},
			{
				Header: "Price",
				id: "skus.price_retail",
				className: 'right-column',
				width: 120,
				accessor: r => r.skus.price_retail,
				Cell: props => <span>${props.value}</span>
			},
			// {
			// 	Header: "Location",
			// 	id: "location",
			// 	accessor: r => r.locations.name,
			// 	Cell: props => <Link to={"/locations/"+props.original.pkey}>{props.value}</Link>
			// },
			{
				Header: "Quantity",
				id: "quantity",
				className: 'center-column',
				width: 120,
				filterable: false,
				accessor: r => r.skus.serialized === false ? r.quantity : r.inventory_serializeds.length
			},
			{
				Header: "Checkout",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 120,
				Cell: props => {
					return (
						<span>
							{
								//Check if serialized or out of stock
								props.original.skus.serialized !== false || props.original.quantity <= 0 ?
									null :
									<Button className="primary-button"
									        style={{ marginTop: '5px' }}
									        onClick={this.addToCart(
										        props.original.pkey,
										        null,
										        props.original.skus?.taxable ?? true,
										        props.original.skus?.sku || 'This item'
									        )}
									        size={"sm"} block={true}><i
										className={"fa fa-shopping-cart"}/>&nbsp;&nbsp;Add</Button>
							}
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={{
								pathname: "/inventory/" + props.original.pkey,
								inventoryProps: {parent: props.original.pkey}
							}}>
								<Button color="green-meadow" size={"sm"} block={true} style={{ marginTop: '5px' }}>
									<i className={"fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			}
		);

		const CustomPagination = ({
			                          page,
			                          pageSize,
			                          pages,
			                          data,
			                          canPrevious,
			                          canNext,
			                          onPageChange,
			                          onPageSizeChange,
			                          pageSizeOptions
		                          }) => {
			const total = this.state.totalCount;

			const start = page * pageSize + 1;
			const end = page * pageSize + data?.length;
			const options = pageSizeOptions.map(size => {
				return {
					value: size,
					label: size !== 'All' ? `${size} per page` : size
				};
			});
			return (
				<div style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					padding: "8px 12px",
					fontSize: "12px"
				}}>
					<div>
						Showing {start}-{end}
					</div>

					<div style={{ display: "flex", gap: "6px", maxWidth: "30%" }}>
						<Select
							styles={this.customStyles}
							className={classNames('basic-single', {hasSelection: pageSize != null && pageSize.length}, 'btn-w-lg')}
							classNamePrefix="select"
							onChange={(e) => {
								onPageSizeChange(Number(e.value))
								console.log(pageSize)
							}}
							value={options.find(opt => opt.value === pageSize)}
							isSearchable={true}
							menuPlacement={"top"}
							placeholder={"Table Size"}
							options={options}
						/>
						<Button style={{backgroundColor: "#efefef",
							color: "black",
							opacity: !canPrevious ? 0.4 : 1,
							cursor: !canPrevious ? 'not-allowed' : 'pointer',
							filter: !canPrevious ? 'grayscale(60%)' : 'none'}} onClick={() => onPageChange(page - 1)} disabled={!canPrevious}>
							&lt;
						</Button>
						<span style={{fontSize: 12, alignSelf: "center"}}>Page {page + 1} / {pages}</span>
						<Button style={{backgroundColor: "#efefef",
							color: "black",
							opacity: !canNext ? 0.4 : 1,
							cursor: !canNext ? 'not-allowed' : 'pointer',
							filter: !canNext ? 'grayscale(60%)' : 'none'}} onClick={() => onPageChange(page + 1)} disabled={!canNext}>
							&gt;
						</Button>
					</div>
				</div>
			);
		};

		return (
			<div>

					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Products')}
							<div className="statusFilter" style={{width: '200px'}}>
								<Select
									styles={this.customStyles}
									className={classNames('basic-single', {hasSelection: this.state.filter.in_stock != null && this.state.filter.in_stock.length})}
									classNamePrefix="select"
									onChange={this.doFilter}
									value={this.state.inStock}
									isClearable={true}
									isSearchable={true}
									name="in_stock"
									placeholder={"Filter Stock"}
									options={[
										{value: null, label: 'All'},
										{value: true, label: 'In-Stock'},
										{value: false, label: 'Out of Stock'},
									]}
								/>
							</div>
							<div className={'statusFilter col-2'}>
								<Select
									key={this.state.selectedGroups}
									styles={this.customStyles}
									classNamePrefix="select"
									placeholder={"Select Inventory Group"}
									isMulti
									isClearable
									onChange={this.handleGroups}
									value={this.state.selectedGroups.map(group => {
										return (
											{value: group.value, label: group.label})
									})}
									options={this.state.groups.map(group => {
										return (
											{value: group.pkey, label: group.name})
									})}
								/>
							</div>
							{this.renderHeaderRight("Products", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						// PaginationComponent={CustomPagination}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultPageSize={limit}
						pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000, 'All']}
						className="-highlight -striped"
						renderPageSizeOptions={this.renderPageSizes}
						minRows={0}
					/>

				{APPCONFIG.settings.isDev() ? null :
					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				}
			</div>
		)
	}
}
export default Framework.Components.withRootState(Inventories);
